import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';

export function useOnboardingVideoEvent() {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();
  const accountId = currentUser?.professional?.id;

  const trackModalOpened = ({ platform }: { platform: 'web' | 'mobile' }) => {
    analytics.track('Onboarding - Educational Video - Rendered', {
      context: 'Onboarding',
      subcontext: 'Educational Video',
      action: 'Rendered',
      account_id: accountId,
      platform,
    });
  };

  const trackModalClosed = ({ platform }: { platform: 'web' | 'mobile' }) => {
    analytics.track('Onboarding - Educational Video - Closed', {
      context: 'Onboarding',
      subcontext: 'Educational Video',
      action: 'Closed',
      account_id: accountId,
      platform,
    });
  };

  const trackLearnMore = ({ platform }: { platform: 'web' | 'mobile' }) => {
    analytics.track('Onboarding - Learn More Button - Clicked', {
      context: 'Onboarding',
      subcontext: 'Learn More Button',
      action: 'Clicked',
      account_id: accountId,
      platform,
    });
  };

  return { trackModalOpened, trackModalClosed, trackLearnMore };
}
